import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import imgLogo from '../../assets/img/logo_ingram.png'

const Services = () => {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClickContact = (e) => {
        e.preventDefault();
        navigate('/contact');
    }

    return (
        <>
            <div className="container-grey reveal">
                <div className="prices-block">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-5 prices-anchor reveal" style={{transitionDelay:"0ms"}}>
                                <div className="box-info">
                                        <div className="box-info-title">
                                            <h4 className="text-center green-easy">{t("solutions.services.card1.header")}</h4>
                                        </div>
                                        <div className="separar"></div>
                                        <div className="box-info-description text-center">
                                            <p>{t("solutions.services.card1.description")}</p>
                                        </div>
                                        <div className="box-info-price">
                                            <p className="price text-center"><strong>{t("shared.from")}</strong> <sup className="usd">$</sup><strong>455</strong><sup className="usd">USD</sup></p>
                                            <a className="cta-pill" href="javascript:void();" onClick={(e) => handleClickContact(e)}>{t("shared.contactus")}</a>
                                        </div>
                                    </div>
                            </div>
                            <div className="col-md-5 prices-anchor reveal" style={{transitionDelay:"80ms"}}>
                                    <div className="box-info">
                                        <div className="box-info-title">
                                            <h4 className="text-center green-easy">{t("solutions.services.card2.header")}</h4>
                                        </div>
                                        <div className="separar"></div>
                                        <div className="box-info-description text-center">
                                            <p>{t("solutions.services.card2.description")}</p>
                                            <p>{t("solutions.services.card2.description1")}</p>
                                        </div>
                                        <div className="box-info-price">
                                            <a className="cta-pill" href="javascript:void();" onClick={(e) => handleClickContact(e)}>{t("shared.contactus")}</a>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div className="separar"></div>
                        <div className="container">
                            <div className="row row justify-content-center">
                                <div className="col-md-5 prices-anchor reveal" style={{transitionDelay:"160ms"}}>
                                        <div className="box-info">
                                            <div className="box-info-title">
                                                <h4 className="text-center green-easy">{t("solutions.services.card3.header")}</h4>
                                                {/* <h4 className="text-center green-easy">POD</h4> */}
                                            </div>
                                            <div className="separar"></div>
                                            <div className="box-info-description text-center">
                                                <p>{t("solutions.services.card3.description")}</p>
                                                {/* <p>{t("solutions.services.card3.description1")}</p> */}
                                            </div>
                                            <div className="d-flex justify-content-center">
                                                <img className="logo_ingram" src={imgLogo} alt="logo-ingram" />
                                            </div>

                                            <div className="box-info-price">
                                                <a className="cta-pill" href="javascript:void();" onClick={(e) => handleClickContact(e)}>{t("shared.contactus")}</a>
                                            </div>
                                        </div>
                                </div>
                                <div className="col-md-5 prices-anchor reveal" style={{transitionDelay:"240ms"}}>
                                        <div className="box-info">
                                            <div className="box-info-title">
                                                <h4 className="text-center green-easy">Biblio.digital</h4>
                                            </div>
                                            <div className="separar"></div>
                                            <div className="box-info-description text-center">
                                                <p>{t("solutions.services.card4.description")}</p>
                                                <p>{t("solutions.services.card4.description1")}</p>
                                            </div>
                                            <div className="box-info-price">
                                                <p className="price text-center"><strong>{t("shared.from")}</strong> <sup className="usd">$</sup><strong>18</strong><sup className="usd">USD</sup><br /><small>{t("shared.monthly")}</small></p>
                                                <a className="cta-pill" href="javascript:void();" onClick={(e) => handleClickContact(e)}>{t("shared.contactus")}</a>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div className="separar"></div>
                        <div className="separar"></div>
                        <div className="container ver-mas reveal">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h3 className="green-easy">{t("solutions.features.title")}</h3>
                                </div>
                            </div>
                        </div>
                        <div className="separar"></div>
                        <div className="separar"></div>
                        <div className="separar"></div>
                        <div className="container reveal">
                            <div className="row">
                                <div className="col-md-12">
                                    <div id="price-table" className="tabla-precios">
                                        <table className="table table-responsive">
                                            <tr>
                                                <td className="no-border"></td>
                                                <td className="text-center">
                                                    <h3 className="green-easy"><strong>Basic</strong></h3>
                                                    <strong>{t("shared.from")}</strong><br />
                                                    <h3><sup>$</sup><strong>455</strong><sup>USD</sup></h3>
                                                </td>
                                                <td className="text-center">
                                                    <h3 className="green-easy"><strong>Publisher</strong></h3>
                                                    <h4><strong><a className="cta-pill" href="javascript:void();" onClick={(e) => handleClickContact(e)}>{t("shared.contactus")}</a></strong></h4>
                                                </td>
                                                <td className="text-center">
                                                    <h3 className="green-easy"><strong>{t("solutions.features.table.text15")}</strong></h3>
                                                    <img src={imgLogo} className="logo_ingram" alt="logo-ingram" />
                                                    <h4><strong><a className="cta-pill" href="javascript:void();" onClick={(e) => handleClickContact(e)}>{t("shared.contactus")}</a></strong></h4>
                                                    {/* <strong>{t("shared.from")}</strong><br />
                                                <h3><sup>$</sup><strong>40</strong><sup>USD</sup></h3> */}
                                                </td>
                                                <td className="text-center">
                                                    <h3 className="green-easy"><strong>Biblio.digital</strong></h3>
                                                    <strong>{t("shared.from")}</strong><br />
                                                    <h3><sup>$</sup><strong>18</strong><sup>USD</sup></h3>
                                                    <p><small>{t("shared.monthly")}</small></p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="5" className="header">{t("solutions.features.table.text")}</td>
                                            </tr>
                                            <tbody>
                                                <tr>
                                                    <td>{t("solutions.features.table.text1")}</td>
                                                    <td>- {t("shared.of")} 10<br />{t("shared.publications")}</td>
                                                    <td>+ {t("shared.of")} 10<br /> {t("shared.publications")}</td>
                                                    {/* <td>{t("shared.from")} 1 {t("shared.book")}</td> */}
                                                    <td>{t("solutions.features.table.text16")}</td>
                                                    <td>{t("shared.from")} 60<br /> {t("shared.publications")}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t("shared.distribution")}<br />(ebook /{t("shared.audiobook")}/{t("solutions.features.table.text2")})</td>
                                                    <td>ebook / {t("shared.audiobook")}</td>
                                                    <td>ebook / {t("shared.audiobook")}</td>
                                                    <td>{t("solutions.features.table.text2")}</td>
                                                    <td>ebook / {t("shared.audiobook")}</td>
                                                </tr>
                                                {/*  <tr>
                                                <td>{t("shared.distribution")}<br />(ebook /{t("shared.audiobook")})</td>
                                                <td>ebook / {t("shared.audiobook")}</td>
                                                <td>ebook / {t("shared.audiobook")}</td>
                                                <td>-</td>
                                                <td>ebook / {t("shared.audiobook")}</td>
                                            </tr> */}
                                                <tr>
                                                    <td style={{ "text-transform": "capitalize" }}>{t("solutions.features.table.text3")}</td>
                                                    <td>
                                                        {t("shared.in")} 50 {t("solutions.features.table.text3")}
                                                    </td>
                                                    <td>
                                                        {t("shared.in")} 60 {t("solutions.features.table.text3")}
                                                    </td>
                                                    <td>{t("solutions.features.table.text16")}</td>
                                                    <td>{t("solutions.features.table.text5")}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t("solutions.features.table.text6")}</td>
                                                    <td>-</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("solutions.features.table.text7")}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t("solutions.features.table.text8")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>-</td>
                                                    <td>-</td>
                                                    <td>-</td>
                                                </tr>
                                                <tr>
                                                    <td>{t("solutions.features.table.text9")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>-</td>
                                                    <td>-</td>
                                                    <td>-</td>
                                                </tr>
                                                <tr>
                                                    <td>{t("solutions.features.table.text10")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t("solutions.features.table.text11")}</td>
                                                    <td>-</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t("solutions.features.table.text12")}</td>
                                                    <td>-</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>-</td>
                                                </tr>
                                                <tr>
                                                    <td>{t("solutions.features.table.text13")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t("solutions.features.table.text14")}</td>
                                                    <td>-</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                    <td>{t("shared.yes")}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Services;